import $ from 'jquery';
import ajax from '../services/ajax';
import config from '../config/index.js';
import cookieUtil from 'js-cookie';
import _get from 'lodash.get';
import _ from 'underscore';
import authCheckUtil from '../utils/auth_check_util';

class SignIn {
    constructor() {
        this.authUrl = '__/auth/account';
        this.tokenUrl = '__/auth/validate';
        this.scopedSubmitListener = this.submitListener.bind(this);
    }

    submitListener(e) {
        e.preventDefault();
        this.handleSubmit();
    }

    formatErrorResponse(err) {
        let response;
        try {
            response = JSON.parse(err[0].responseText).error;
        } catch (error) {
            response = 'unknown error occurred';
        }
        return response;
    }

    // TODO: make this show up in the error container
    showFail(response) {
        this.$errorMsgContainer.html(`
            <h1>Oops we ran into a problem.</h1>
            <h1>${response}</h1>
        `);
    }

    showLoginSuccess() {
        this.$signInContainer.html(`
            <h1>Log In Success. You are now logged in.</h1>
        `);
    }

    showGetUserSuccess() {
        const provider = this.userData.p;
        const username = this.userData.n;
        const uuid = this.userData.u;
        this.$signInContainer.html(`
            <h1>Log In Success. You are now logged in.</h1>
            <h1>This is your user information:</h1>
            <h1>Authentication Method: ${provider}</h1>
            <h1>User Name: ${username}</h1>
            <h1>Unique Identifier: ${uuid}</h1>
        `);
    }

    login() {
        const { email, password } = this.formData;
        const from = 'https:' + config.get('identity.site_url');
        const loginData = {email, password, from};
        return ajax(this.authUrl, {
            method: 'POST',
            data: loginData
        }).then((tokenResponse) => {
            this.token = _get(tokenResponse, 'login.token');
        });
    }

    checkToken() {
        // TODO: look into storing this in localstorage
        const token = this.token;
        const url = this.tokenUrl;
        const tokenData = {token};
        return ajax(url, {
            method: 'POST',
            data: tokenData
        });
    }

    // TODO: add with a mixin, refactor for image_promise_util
    setSessionCookies($container) {
        const token = this.token;
        const $box = $container;
        const host = location.hostname;
        const parts = host.split('.');
        const tld = '.' + parts[parts.length - 1] + ':' + location.port;
        let subdomain = '';
        if (parts.length > 2) {
            subdomain = parts.slice(0, parts.length - 2).join('.') + '.';
        }
        let count = 1;
        _.each(['fastcompany', 'fastcodesign', 'fastcoexist', 'fastcocreate', 'fastcolabs'], (domain) => {
            let src = '//' + subdomain + domain + tld + '/_/image/' + token + '/' + (count++);
            $box.append('<img src="' + src + '">');
        });
        let src = '//www.fastyou.com/_/image/' + token + '/' + (count++);
        $box.append('<img src="' + src + '">');
    }

    getUser() {
        const authCookie = cookieUtil('fc_auth');
        if (authCookie) {
            return authCheckUtil().then((userData) => {
                this.userData = _get(userData, 'user');
            });
        }
        throw new Error('fc_auth cookie not available.');
    }

    handleSubmit() {
        this.serializeForm();
        return this.login().then(() => {
            return this.checkToken();
        }).then(()=> {
            this.showLoginSuccess();
            this.setSessionCookies(this.$signInContainer);
            return this.getUser();
        }).then(() => {
            return this.showGetUserSuccess();
        }).catch((err) => {
            this.showFail(this.formatErrorResponse(err));
        });
    }

    validateForm() {
        // TODO: validate form
    }

    serializeForm() {
        this.formData = this.$form.serializeArray()
            .reduce((serializedData, current) => {
                serializedData[current.name] = current.value;
                return serializedData;
            }, {});
        return this.formData;
    }

    on() {
        this.$signInContainer = $('.js-sign-in-column');
        this.$errorMsgContainer = this.$signInContainer.find('.error-messages');
        this.$form = $('.js-sign-in-form');
        this.action = this.$form.attr('action');
        this.method = this.$form.attr('method');
        if (config.get('userData')) {
            this.userData = config.get('userData');
            return this.showGetUserSuccess();
        }
        this.$form.on('submit', this.scopedSubmitListener);
    }

    off() {
        this.$form.off('submit', this.scopedSubmitListener);
    }
}

export default new SignIn();


